import React from 'react';

import EmptyUserProfiles from 'views/Sagemaker/components/EmptyUserProfiles';
import { NButton, NTable } from '@innersource-nn/novoui-react';
import useUserProfiles from 'views/Sagemaker/hooks/useUserProfiles';
import { Environment, UserProfilesMessage } from 'types/Environment';
import { useModal } from 'hooks/useModal';
import { CircularProgress } from '@mui/material';

const tableHeaders = [
    { header: 'Username', key: 'username' },
    { header: 'User group', key: 'group' },
    { header: 'User role', key: 'role' },
    { header: 'Actions', key: 'actions' },
];

type Props = {
    environment: Environment;
};

export default function UserProfiles({ environment }: Props) {
    const { openUserProfilesModal } = useModal();

    const {
        userProfiles,
        loadingUserProfiles,
        generateUrl,
        deleteUserProfile,
    } = useUserProfiles(environment);

    const addUserProfileActions = (
        userProfiles: UserProfilesMessage[],
    ): UserProfilesMessage[] => {
        return userProfiles.map((userProfile) => {
            const { username, group, role } = userProfile;
            return {
                ...userProfile,
                actions: (
                    <div className="flex gap-8">
                        <NButton
                            size="tiny"
                            variant="outline"
                            square
                            leftIcon="external"
                            isLoading={userProfile.urlLoading}
                            onClick={() => generateUrl(group, username, role)}
                        >
                            Launch
                        </NButton>
                        <NButton
                            size="tiny"
                            className="outline-red-button"
                            square
                            isLoading={userProfile.deleteLoading}
                            onClick={() => deleteUserProfile(group, role)}
                        >
                            Delete
                        </NButton>
                    </div>
                ),
            };
        });
    };

    return (
        <div>
            <div className="w-full flex justify-between items-center pt-24">
                <h2 className="font-bold text-true-blue">User profiles</h2>
                {!!userProfiles.length && (
                    <NButton
                        square
                        size="small"
                        variant="outline"
                        onClick={() =>
                            openUserProfilesModal({
                                environment,
                            })
                        }
                    >
                        New User Profile
                    </NButton>
                )}
            </div>
            {loadingUserProfiles ? (
                <div className="py-32 flex flex-col justify-center items-center">
                    <CircularProgress />
                    <div className="w-1/2 text-base text-true-blue flex flex-col items-center">
                        <h1 className="text-lg my-8 font-bold">
                            Retriving user profiles...
                        </h1>
                    </div>
                </div>
            ) : (
                <div className="mt-12">
                    {!userProfiles.length ? (
                        <EmptyUserProfiles environment={environment} />
                    ) : (
                        <NTable
                            headers={tableHeaders}
                            items={addUserProfileActions(userProfiles)}
                            columnBorder={true}
                            rowKey="username"
                        />
                    )}
                </div>
            )}
        </div>
    );
}
